module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('b-card', [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('b-button', {
    attrs: {
      "to": {
        name: 'service-list',
        params: {
          save: true
        }
      },
      "size": "sm",
      "variant": "link"
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  })]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.caption))]), _vm._v(" 服务\n    ")], 1), _vm._v(" "), _c('b-form', {
    on: {
      "submit": _vm.onSubmit,
      "reset": _vm.onReset
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "服务名",
      "label-for": "name"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "name",
      "type": "text",
      "required": ""
    },
    model: {
      value: (_vm.data.name),
      callback: function($$v) {
        _vm.$set(_vm.data, "name", $$v)
      },
      expression: "data.name"
    }
  })], 1), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "label": "代号",
      "label-for": "code"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "code",
      "type": "text",
      "required": "",
      "disabled": _vm.isUpdate
    },
    model: {
      value: (_vm.data.code),
      callback: function($$v) {
        _vm.$set(_vm.data, "code", $$v)
      },
      expression: "data.code"
    }
  })], 1), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "label": "创建实例方式",
      "label-for": "type"
    }
  }, [_c('b-form-select', {
    attrs: {
      "id": "type",
      "options": _vm.service_types,
      "required": ""
    },
    model: {
      value: (_vm.data.type),
      callback: function($$v) {
        _vm.$set(_vm.data, "type", $$v)
      },
      expression: "data.type"
    }
  })], 1), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "label": "服务分类",
      "label-for": "category"
    }
  }, [_c('b-form-select', {
    attrs: {
      "id": "category",
      "options": _vm.category_types,
      "required": ""
    },
    model: {
      value: (_vm.data.category),
      callback: function($$v) {
        _vm.$set(_vm.data, "category", $$v)
      },
      expression: "data.category"
    }
  })], 1), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "label": "联系人",
      "label-for": "admin_id"
    }
  }, [_c('el-select', {
    staticClass: "mb-2",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "multiple": "",
      "filterable": "",
      "id": "service_code"
    },
    model: {
      value: (_vm.data.admin_id),
      callback: function($$v) {
        _vm.$set(_vm.data, "admin_id", $$v)
      },
      expression: "data.admin_id"
    }
  }, _vm._l((_vm.admins), function(admin) {
    return _c('el-option', {
      key: admin.value,
      attrs: {
        "label": admin.text,
        "value": admin.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "label": "文档URL",
      "label-for": "doc_url"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "doc_url",
      "type": "text",
      "required": ""
    },
    model: {
      value: (_vm.data.doc_url),
      callback: function($$v) {
        _vm.$set(_vm.data, "doc_url", $$v)
      },
      expression: "data.doc_url"
    }
  })], 1), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "label": "服务URL",
      "label-for": "index_url"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "index_url",
      "type": "text",
      "required": ""
    },
    model: {
      value: (_vm.data.index_url),
      callback: function($$v) {
        _vm.$set(_vm.data, "index_url", $$v)
      },
      expression: "data.index_url"
    }
  })], 1), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "label": "创建实例接口URL",
      "label-for": "index_url"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "index_url",
      "type": "text",
      "required": _vm.data.type === 'auto'
    },
    model: {
      value: (_vm.data.create_url),
      callback: function($$v) {
        _vm.$set(_vm.data, "create_url", $$v)
      },
      expression: "data.create_url"
    }
  })], 1), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "label": "简介",
      "label-for": "brief"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "id": "brief",
      "rows": "3",
      "required": ""
    },
    model: {
      value: (_vm.data.brief),
      callback: function($$v) {
        _vm.$set(_vm.data, "brief", $$v)
      },
      expression: "data.brief"
    }
  })], 1), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "label": "图片",
      "label-for": "img_url"
    }
  }, [_c('image-upload', {
    attrs: {
      "id": "img_url",
      "fileObj": _vm.data.img_url
    },
    on: {
      "update:fileObj": function($event) {
        return _vm.$set(_vm.data, "img_url", $event)
      },
      "update:file-obj": function($event) {
        return _vm.$set(_vm.data, "img_url", $event)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('b-button', {
    attrs: {
      "type": "submit",
      "size": "sm",
      "variant": "outline-primary"
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" 提交")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "type": "reset",
      "size": "sm",
      "variant": "outline-secondary"
    }
  }, [_c('i', {
    staticClass: "fa fa-remove"
  }), _vm._v(" 返回")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-d98e2e12!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/service/ServiceCreate.vue
// module id = QY5I
// module chunks = 4